import { __rest, __read, __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import React__default from 'react';
import { useDropdownToggle } from '@restart/ui';
import classNames from 'classnames';

var DropdownItem = function (_a) {
    var children = _a.children, onClick = _a.onClick, icon = _a.icon, _b = _a.closeMenuAfterClick, closeMenuAfterClick = _b === void 0 ? true : _b, disabled = _a.disabled, props = __rest(_a, ["children", "onClick", "icon", "closeMenuAfterClick", "disabled"]);
    var _c = __read(useDropdownToggle(), 2), toggle = _c[1].toggle;
    var handleClick = function () {
        if (disabled)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (closeMenuAfterClick)
            toggle(false);
    };
    var additionalButtonProps = __assign(__assign({}, ((props === null || props === void 0 ? void 0 : props['data-testid']) ? { 'data-testid': "".concat(props['data-testid'], "-button") } : {})), ((props === null || props === void 0 ? void 0 : props['data-cy']) ? { 'data-cy': "".concat(props['data-cy'], "-button") } : {}));
    return (React__default.createElement("li", __assign({ className: classNames('nv-contextual-menu-item', { 'nv-contextual-menu-item--disabled': disabled }) }, props),
        React__default.createElement("button", __assign({}, additionalButtonProps, { "aria-disabled": disabled, className: "nv-contextual-menu-item-button", onClick: handleClick, type: "button" }),
            icon && React__default.createElement("span", { className: "nv-contextual-menu-item-icon" }, icon),
            children)));
};

export { DropdownItem as default };
//# sourceMappingURL=DropdownItem.esm.js.map
